<template>
    <div class="platform_advantages">
        <div class="container main_width main_color m_0">
            <div class="title">平台优势</div>
            <div class="content">
                <div class="item" v-for="(item,index) in list" :key="index">
                    <div class="icon">
                        <img :src="item.img" alt=""></img>
                    </div>
                    <div class="text_box">
                        <div class="text">{{ item.title }}</div>
                        <div class="des">{{ item.des }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import platformAdvantages1 from '../../../static/images2/platform_advantages1.png'
import platformAdvantages2 from '../../../static/images2/platform_advantages2.png'
import platformAdvantages3 from '../../../static/images2/platform_advantages3.png'
import platformAdvantages4 from '../../../static/images2/platform_advantages4.png'
export default {
  name: "platform-advantages",
  data() {
    return {
        list: [
            {
                img: platformAdvantages1,
                title: '最新最全的车架号数据',
                des: '提供车架号锁定车辆具体4S销售款型 查询，且周边数据丰富，广受行业用 户喜爱'
            },
            {
                img: platformAdvantages2,
                title: '海量原厂级别精度的配件数据',
                des: '90个品牌配件数据集于一身，经深度 优化整合，提供远优于原厂的查询操 作体验'
            },
            {
                img: platformAdvantages3,
                title: '庞大的用户基数',
                des: '多年专业查询工具属性，累积近6000 万行业用户，已成为汽车后市场各行 业业务流量入口'
            },
            {
                img: platformAdvantages4,
                title: '领先全网的车辆数据',
                des: '目前汽修宝的维保、出险记录和车况 等查询业务的查得率高，查询结果准、 查询速度快、查询价格实惠，已成为 二手车交易的查询标准'
            },
        ]
    };
  }
};

</script>
<style lang="less" scoped>
@import "../../assets/style/utils.less";
.platform_advantages {
    background: #F5F9FF;
    padding: .px2vw(48)[@result] 0;
    text-align: center;
    .title {
        font-weight: 700;
        font-size: .px2vw(32)[@result];
        margin-bottom: .px2vw(32)[@result];
    }
    .content {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: .px2vw(1280)[@result];
        margin: 0 auto;
        & > .item {
            width: .px2vw(296)[@result];
            height: .px2vw(396)[@result];
            background: #FFFFFF;
            border-radius: .px2vw(10)[@result];
            color: #4E5969;
            line-height: .px2vw(24)[@result];
            text-align: left;
            font-size: 0;
            .text_box {
                padding: .px2vw(16)[@result];
                font-size: .px2vw(16)[@result];
                text-align: justify;
                .text {
                    font-weight: 500;
                    font-size: .px2vw(20)[@result];
                    color: #1D2129;
                    line-height: .px2vw(28)[@result];
                    margin-bottom: .px2vw(12)[@result];
                }
            }
            .icon {
                max-width: .px2vw(296)[@result];
                max-height: .px2vw(220)[@result];
                img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                }
            }
        }
    }
}
@media screen and (max-width: 900px) {
    .platform_advantages {
        padding: .h5px2vw(32)[@result] .h5px2vw(24)[@result];
        .title {
            font-size: .h5px2vw(32)[@result];
            margin-bottom: 0;
        }
        .content {
            width: 100%;
            flex-wrap: wrap;
            & > .item {
                margin-top: .h5px2vw(24)[@result];
                width: .h5px2vw(338)[@result];
                height: .h5px2vw(412)[@result];
                border-radius: .h5px2vw(10)[@result];
                .text_box {
                    padding: .h5px2vw(16)[@result];
                    font-size: .h5px2vw(20)[@result];
                    .text {
                        font-size: .h5px2vw(24)[@result];
                        line-height: .h5px2vw(32)[@result];
                        margin-bottom: .h5px2vw(8)[@result];
                        font-weight: bold;
                    }
                    .des {
                        line-height: .h5px2vw(28)[@result];
                    }
                }
                .icon {
                    max-width: 100%;
                    max-height: .h5px2vw(220)[@result];
                    img {
                        width: 100%;
                        height: .h5px2vw(220)[@result];
                        object-fit: cover;
                        border-radius: .h5px2vw(10)[@result];
                    }
                }
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/index/platformAdvantages.vue